// import moment from 'moment';
import Model from 'lib/Model';
import { v4 as uuid } from 'uuid';
import Pond from 'model/Pond';

import moment from 'moment';


export default Model.extend({
	defaults: function()
	{
		var now = new Date();
		return {
			date: now.toISOString().substr(0,10),
			created_at: now.getTime(),
			uuid: uuid()
		};
	},

	idAttribute: 'uuid',

	toString: function() {
		return 'visite du '+moment( this.get('date') ).format('DD/MM/YYYY');
	},


	setPond: function( pond )
	{
		this.set('pond_id',pond.get('id'));
		this.set('pond_uuid',pond.get('uuid'));
		this.set('city_name',pond.get('city_name'));
	},
	getPond: function()
	{
		if( this._pond )
		{
			return this._pond;
		}

		return new Pond;
	},
	setUser: function( user )
	{
		this.set('user_id',user.get('id'));
		this.set('user_uuid',user.get('uuid'));
		this.set('user_name',user.get('name'));
	},

	isSaving: function()
	{
		return this.get('saving') == true;
	},

	getIcon: function()
	{
		if( this.isSaving() ) { return '<i class="fas fa-spinner fa-spin text-secondary"></i>'; }
		if( this.hasError() ) { return '<i class="fas fa-exclamation-triangle text-danger"></i>'; }
		if( this.isSavable() ) { return '<i class="far fa-hourglass-half text-secondary"></i>'; }
		if( this.get('todo') == 'draft' ) { return '<i class="far fa-hourglass-half text-secondary"></i>'; }
		return '<i class="fas fa-check color-green"></i>';
	},


/*
	validate: function( data )
	{
		var error = {}

		_.each( app.getStore('data').get('form'), function( section )
		{
			_.each( section.list, function( field )
			{
				if( _.isEmpty( data[ field.id ] ) )
				{
					if( field.required )
					{
						error[ field.id ] = "Ce champ est obligatoire";
					}
					return;
				}
			});
		});

		if( !_.isEmpty( data.date ) && data.date > (new Date()).toISOString().substr(0,10) )
		{
			error.date = "La date ne peut être postérieur à aujourd'hui";
		}
console.log( error);
		if( _.size( error ) ) return error;
	},
*/

	parse: function( attrs )
	{
		if( _.isObject( attrs.info ) )
		{
			_.each( attrs.info, function( val, key )
			{
				attrs[ 'info_' + key ] = val;
			});
			delete attrs.info;
		}
		return attrs;
	},

	toJSON: function()
	{
		var attrs = { info: {} };
		_.each( this.attributes, function( val, key )
		{
			if( key.substr( 0, 5 ) == 'info_' )
			{
				attrs.info[key.substr(5)] = val;
			}
			else
			{
				attrs[key] = val;
			}
		});
		return attrs;
	}
});
